export default "__VITE_ASSET__ee70ff03__"